const AUTH_STORAGE_KEYS = [
  'access_token',
  'access_token_expires_at',
  'refresh_token',
  'refresh_token_expires_at',
  'user',
  'is_guest_user',
  'redirectURL',
] as const;

export const clearAuthStorage = (): void => {
  AUTH_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });
};

export const getStoredUser = <T = Record<string, unknown>>(): T | null => {
  const userStr = localStorage.getItem('user');
  if (!userStr) {
    return null;
  }

  try {
    return JSON.parse(userStr) as T;
  } catch (error) {
    console.warn('Failed to parse stored user. Clearing persisted auth state.', error);
    clearAuthStorage();
    return null;
  }
};
